<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import {useMutation, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import {errorToast, successToast} from "@/composables/useToasts";

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  approvalId: {
    type: Number,
    required: true
  },
  category: {
    type: String,
    required: true
  }
});

const queryClient = useQueryClient();

const {mutate: handleReject, isPending} = useMutation({
  mutationFn: () => axios.patch(`/ajax/v2/approval-center/${props.approvalId}/reject`),
  onSuccess: () => {
    queryClient.invalidateQueries({
      queryKey: ['approvals', props.category]
    })

    successToast('Successfully rejected update');
  },
  onError: () => {
    errorToast('There was an error rejecting the update');
  },
  onSettled: () => {
    emit('close');
  }
});
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[720px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <ModalHeader>
            <ModalHeading>Are you sure you'd like to reject this update?</ModalHeading>

            <ModalSubText>
              Once <span class="tw-font-bold">Continue</span> has been pressed, this cannot be undone.
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>
        <div class="tw-flex tw-items-center tw-gap-4 tw-self-end">
          <DefaultButton
            variant="primary-inverted"
            @click="emit('close')"
          >
            Cancel
          </DefaultButton>
          <DefaultButton
            :disabled="isPending"
            :loading="isPending"
            @click="handleReject"
          >
            Continue
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
